"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerWithContactResponse = void 0;
class PartnerWithContactResponse {
}
exports.PartnerWithContactResponse = PartnerWithContactResponse;
//# sourceMappingURL=partner-contact.response.js.map